
<!-- ========================= -->
<!-- CARRUSEL PRINCIPAL -->
<!-- ========================= -->

<div id="carouselTecNM" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">

  <div class="carousel-indicators">
    <button *ngFor="let img of images; let i = index" type="button" data-bs-target="#carouselTecNM"
      [attr.data-bs-slide-to]="i" [class.active]="i === 0" [attr.aria-label]="'Slide ' + (i + 1)">
    </button>
  </div>

  <div class="carousel-inner">

    <div *ngFor="let img of images; let i = index" class="carousel-item" [class.active]="i === 0">

      <div class="slider-container">

        <a *ngIf="img.link" [href]="img.link" target="_blank">

          <img [src]="img.src" class="slider-img" alt="Imagen del carrusel">

        </a>

        <img *ngIf="!img.link" [src]="img.src" class="slider-img" alt="Imagen del carrusel">

      </div>

    </div>

  </div>

  <button class="carousel-control-prev" type="button" data-bs-target="#carouselTecNM" data-bs-slide="prev">

    <span class="carousel-control-prev-icon"></span>

  </button>

  <button class="carousel-control-next" type="button" data-bs-target="#carouselTecNM" data-bs-slide="next">

    <span class="carousel-control-next-icon"></span>

  </button>

</div>
 
<!-- ========================= -->
<!-- CONTENIDO PRINCIPAL -->
<!-- ========================= -->

<div class="container my-5">
  

  <div class="row">


    <!-- =================================== -->
    <!-- AVISOS Y COMUNICADOS -->
    <!-- =================================== -->

    <div class="col-lg-4 col-md-5">

      <div class="col-lg-1 d-none d-lg-flex protocolos-contenedor">

        <div class="protocolos-titulo">
          Protocolos contra el hostigamiento
        </div>
    
    <div class="botones-verticales">

        <a href="https://www.tecnm.mx/archivos/anexos/ANEXO%201%20Protocolo%20HSyAS.pdf?pdf=145801" target="_blank" rel="noopener noreferrer">
            1.- PROTOCOLO PARA LA PREVENCIÓN, ATENCIÓN Y SANCIÓN DEL HOSTIGAMIENTO SEXUAL Y ACOSO SEXUAL
        </a>

        <a href="https://www.tecnm.mx/?vista=Protocolo_Actuacion" target="_blank" rel="noopener noreferrer">
            2.- PROTOCOLO DE ACTUACION CON PERSPECTIVA DE GÉNERO,Y AVISO SOBRE ACOSO y HOSTIGAMIENTO SEXUAL.
        </a>

        <a href="https://www.tecnm.mx/archivos/anexos/Pronunciamiento_Cero_Tolerancia_HA_AS_TecNM_2023.pdf?pdf=142238" target="_blank" rel="noopener noreferrer">
            3.- PRONUNCIAMIENTO DE CERO TOLERANCIA AL HOSTIGAMIENTO SEXUAL Y AL ACOSO SEXUAL EN EL TECNOLÓGICO NACIONAL DE MÉXICO
        </a>

        </div>

    </div>


      <div class="avisos-panel">

        <h5 class="avisos-title">
          <i class="bi bi-megaphone-fill"></i>
          Avisos y Comunicados
        </h5>

        <div id="avisosCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">

          <div class="carousel-inner">

            <div class="carousel-item active">
              <img src="assets/carrusel_vertical/poster1.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/difusion.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <a href="assets/CEPCI_ITSE/anexos_etica/Acuerdo Codigo De Etica Y Lineamientos Generales.pdf"
                target="_blank"
                rel="noopener noreferrer">

                <img src="assets/carrusel_vertical/a0.png" class="aviso-slider-img">

              </a>
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C41.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C42.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C43.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C44.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C45.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/c9.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/c1.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/c2.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/j1.jpg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/j2.jpg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/j3.jpg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/j4.jpg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/j5.jpg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/j6.jpg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/a1.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/a2.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/a3.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/a4.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/a5.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/b1.jpg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/b2.PNG" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/b3.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/b4.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/b5.PNG" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/b6.PNG" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/b6.PNG" class="aviso-slider-img">
            </div>


            <div class="carousel-item">
              <img src="assets/carrusel_vertical/c3.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/c4.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/c5.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/c6.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/c7.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/c8.png" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C35.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C36.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C37.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C38.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C39.jpeg" class="aviso-slider-img">
            </div>

            <div class="carousel-item">
              <img src="assets/carrusel_vertical/C40.jpeg" class="aviso-slider-img">
            </div>

          </div>

          <button class="carousel-control-prev" type="button" data-bs-target="#avisosCarousel" data-bs-slide="prev">

            <span class="carousel-control-prev-icon"></span>

          </button>

          <button class="carousel-control-next" type="button" data-bs-target="#avisosCarousel" data-bs-slide="next">

            <span class="carousel-control-next-icon"></span>

          </button>

        </div>

      </div>

     
      <!-- SÍGUENOS (Facebook) -->
      <div class="siguenos-panel mt-4">

        <h5 class="siguenos-title">
          <i class="bi bi-facebook"></i>
          Síguenos
        </h5>

        <div class="siguenos-embed">

          <iframe
            title="Facebook TecNM Escárcega"
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FTecNMEscarcega&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            width="100%"
            height="500"
            style="border:none;overflow:hidden"
            scrolling="no"
            frameborder="0"
            allowfullscreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
          </iframe>

        </div>

        <a
          class="siguenos-link"
          href="https://www.facebook.com/TecNMEscarcega"
          target="_blank"
          rel="noopener noreferrer">
          Abrir página en Facebook
        </a>

      </div>

    </div>

    <!-- =================================== -->
    <!-- CONTENIDO -->
    <!-- =================================== -->

    <div class="col-lg-8 col-md-7 contenido">

      <h2 class="titulo-principal">
        TECNM CAMPUS ESCÁRCEGA
      </h2>

      <p class="sub-info">
        ITSESCARCEGA – INICIO – Última actualización: 10 Junio 2026
      </p>


      <h3 class="seccion-titulo">
        POLÍTICAS INSTITUCIONALES
      </h3>

      <!-- MISIÓN -->

      <div class="policy-card">

        <div class="policy-icon">
          <i class="bi bi-bullseye"></i>
        </div>

        <div class="policy-content">

          <h5>MISIÓN</h5>

          <p>
            Formar profesionistas competentes ofreciendo un servicio educativo
            integral de calidad certificada que permite mejorar el nivel de vida
            de la sociedad de una manera justa y equitativa contribuyendo al
            desarrollo sustentable de la región.
          </p>

        </div>

      </div>

      <!-- VISIÓN -->

      <div class="policy-card">

        <div class="policy-icon vision">
          <i class="bi bi-eye-fill"></i>
        </div>

        <div class="policy-content">

          <h5>VISIÓN</h5>

          <p>
         Ser una institución líder en el Estado de Campeche, con un sistema de gestión integrado y una oferta educativa acreditada en todos sus niveles, que genere un impacto significativo en el desarrollo económico, laboral, social y cultural. 
          </p>

        </div>

      </div>

      <!-- POLÍTICA INTEGRAL -->

      <div class="policy-card">

        <div class="policy-icon integral">
          <i class="bi bi-shield-check"></i>
        </div>

        <div class="policy-content">

          <h5>POLÍTICA INTEGRAL</h5>

          <p>
          El ITSE establece el compromiso de brindar un servicio educativo de calidad, implementando y mejorando continuamente sus procesos en armonía con el medio ambiente y la magnitud de sus riesgos, orientándolos hacia la satisfacción de la comunidad tecnológica, el uso racional de los recursos y el cumplimiento de los requisitos legales aplicables, mediante la implementación y difusión de objetivos y acciones para prevenir y reducir la contaminación, accidentes y enfermedades de trabajo a través de la mejora continua y eficacia de los Sistemas de Gestión, conforme a las Normas ISO 9001, ISO 14001 e ISO 45001, así como promoviendo la igualdad de oportunidades, mediante la Norma Mexicana NMX-R-025-SCFI-2015
          </p>

        </div>

      </div>

      <!-- IGUALDAD -->

      <div class="policy-card">

        <div class="policy-icon igualdad">
          <i class="bi bi-people-fill"></i>
        </div>

        <div class="policy-content">

          <h5>
            POLÍTICA DE IGUALDAD DE GÉNERO Y NO DISCRIMINACIÓN DEL TECNM
          </h5>
          <P>
         La comunidad del Tecnológico Nacional de México establece el compromiso con la promoción y ejercicio de los derechos
          humanos para toda persona que integra los Institutos, Unidades, Centros y Oficinas centrales; garantizando 
          (en el ámbito de competencia, facultades y responsabilidades), el principio de igualdad sustantiva entre mujeres y 
          hombres así como el derecho fundamental a la no discriminación en los procesos y condiciones laborales y escolares,
           quedando prohibido el maltrato, violencia y segregación a cualquier persona de la comunidad por parte de las autoridades
            o entre la misma comunidad en cualquier forma de distinción, exclusión o restricción que se encuentre basada en el origen
             étnico o nacional, color de piel, apariencia física, cultura, sexo, género, edad, discapacidad, condición social o económica, 
             condiciones de salud, embarazo, lengua, religión, opiniones, preferencias sexuales, estado civil, situación migratoria, 
             situación familiar, antecedentes penales, responsabilidades familiares o cualquier otra, que tenga por objeto impedir o
              anular el reconocimiento o el ejercicio de los derechos humanos, laborales o escolares de la comunidad, o impida la 
              igualdad real de oportunidades. </P>
        

        </div>

      </div>

      <!-- ENERGÉTICA -->

      <div class="policy-card">

        <div class="policy-icon energia">
          <i class="bi bi-lightning-charge-fill"></i>
        </div>

        <div class="policy-content">

          <h5>POLÍTICA ENERGÉTICA</h5>

          <p> 
             El Tecnológico Nacional de México establece el compromiso de orientar todas las actividades del Proceso Educativo, 
            hacia el respeto del medio ambiente, mediante la implementación de su Sistema de Gestión de la Energía (SGEn) basado 
            en la norma ISO 50001:2018 NMX-J-SAA-50001-ANCE-IMNC-2019, logrando la mejora continua de su desempeño energético,
             utilizando como base el uso eficiente de la energía, asegurando la disponibilidad de la información y de los recursos 
             para alcanzar los objetivos y metas establecidos, así como cumplir con la legislación aplicable en materia energética, 
             coadyuvando a ser uno de los pilares fundamentales del desarrollo sostenido, sustentable y equitativo de la nación.
          </p>

        </div>

      </div>



    </div>

  </div>

</div>

<!-- ========================= -->
<!-- PLATAFORMAS -->
<!-- ========================= -->

<div class="container py-5">

  <h2 class="text-center mb-5 titulo-seccion">
    Plataformas Institucionales
  </h2>

  <div class="row justify-content-center g-4">

    <div class="col-6 col-md-3">
      <a href="https://acad.itsescarcega.edu.mx/login/index.php" target="_blank" class="card-plataforma">

        <img src="assets/home_logos/moodle.png" alt="Moodle">

      </a>
    </div>

    <div class="col-6 col-md-3">
      <a href="https://www.plataformadetransparencia.org.mx/Inicio" target="_blank" class="card-plataforma">

        <img src="assets/home_logos/naci.png" alt="Transparencia">

      </a>
    </div>
        
    <div class="col-6 col-md-3">
      <a href="https://elibro.net/es/lc/itsescarcega/login_usuario/?next=/es/lc/itsescarcega/inicio" target="_blank"
        class="card-plataforma">
        <img src="assets/home_logos/E_LIBRO1.png" alt="Biblioteca">
      </a>
    </div>

        <div class="col-6 col-md-3">
      <a routerLink="/gestion_institucional/comite-etica" class="card-plataforma">
        <img src="assets/home_logos/comite_de_etica.png" alt="Comité de Ética">
      </a>
    </div>

            <div class="col-6 col-md-3">
      <a  routerLink="/gestion_institucional/contralorias_sociales" class="card-plataforma">
        <img src="assets/home_logos/contro_sociales.png" alt="Biblioteca">
      </a>
    </div>

          

            <div class="col-6 col-md-3">
    <a href="https://tecnmmx.digitaliapublishing.com/"
      target="_blank"
      class="card-plataforma">

      <img src="assets/home_logos/Digitalia.png" alt="Biblioteca">

    </a>
  </div>



  </div>

</div>
